import { useIsFetching, useQueryClient } from '@tanstack/react-query';
import { RefreshCw } from 'lucide-react';

/**
 * Manual refresh: invalidates every pane query (a silent 30s background refetch also runs).
 * Filters and any open drill stay put; `keepPreviousData` means good data is never blanked.
 */
export function RefreshControl() {
  const qc = useQueryClient();
  const fetching = useIsFetching({ queryKey: ['pane'] }) > 0;
  return (
    <button
      type="button"
      onClick={() => void qc.invalidateQueries({ queryKey: ['pane'] })}
      aria-label="Opdater data"
      title="Opdater data"
      className="flex items-center gap-1.5 rounded-brand border border-brand-primary/15 bg-white px-2.5 py-1.5 text-sm text-brand-dark/70 transition-colors hover:border-brand-primary/40 hover:text-brand-primary"
    >
      <RefreshCw size={15} className={fetching ? 'animate-spin' : ''} />
      <span className="hidden sm:inline">Opdater</span>
    </button>
  );
}
